import { render, staticRenderFns } from "./SectionsEditor.vue?vue&type=template&id=07d85a04&scoped=true"
import script from "./SectionsEditor.vue?vue&type=script&lang=js"
export * from "./SectionsEditor.vue?vue&type=script&lang=js"
import style0 from "./SectionsEditor.vue?vue&type=style&index=0&id=07d85a04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d85a04",
  null
  
)

export default component.exports